import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import {
  GetStartedButton,
  Gradient1,
  LandingWrapper,
  SloganBlock,
  UpperBlock,
  UpperBlockWrapper,
  UpperSlogan,
  IconWrapper,
  Gradient2,
  HeaderWrapper,
  MenuButtonsWrapper,
  MenuButton,
  LeftHeader,
  JoinUsButton,
  FeaturesButtons,
  FeatureButton,
  FeatureButtonInner,
  OurPartnersWrapper,
  OurPartnersHeader,
  PartnersList,
  PartnerImageWrapper,
  EdugramForWrapper,
  EdugramForHeader,
  EdugramForText,
  EdugramForButtonsWrapper,
  EdugramForButtonCreator,
  EdugramForButton,
  BenefitsForCreatorsWrapper,
  BenefitsForCreatorsHeader,
  BenefitsForCreatorsSubHeader,
  HamburgerWrapper,
  JoinUsButtonBenefits,
  OurGoalWrapper,
  OurGoalGlobalWrapper,
  BenefitsBlocks,
  BenefitBlocksWrapper,
  OurGoal,
  JoinEdugramWrapper,
  JoinEdugramInnerWrappery,
  FooterWrapper,
  FooterHeading,
  FooterInfoBlock,
  FooterText,
  FooterInfoWrapper,
  MenuWrapper,
  GoalCardsWrapper,
} from '@styled_components/home/styled.components'
// import { LandingHeaderIllustration } from '@public/static/vectorIllustrations/landing-header-illustration'
// import { LiveCourseIcon } from '@public/static/icons/landingPageIcons/live-course-icon'

const LandingHeaderIllustration = dynamic(() =>
  import('@public/static/vectorIllustrations/landing-header-illustration').then(
    (mod) => ({
      default: mod.LandingHeaderIllustration,
    })
  )
)

const LiveCourseIcon = dynamic(() =>
  import('@public/static/icons/landingPageIcons/live-course-icon').then(
    (mod) => ({
      default: mod.LiveCourseIcon,
    })
  )
)

import { NewLogo } from '@public/static/icons/new-logo'
import { AnimatePresence, motion } from 'framer-motion'
import useWindowDimensions from '@hooks/useWindowDimensions'
import { useEffect, useRef, useState } from 'react'
import {
  HamburgerMenuIcon,
  CrossMenu,
} from '@public/static/icons/hamburger-menu-icon'
// import { JoinEdugram1, JoinEdugram2 } from '@public/static/icons/join-edugram'

const JoinEdugram1 = dynamic(() =>
  import('@public/static/icons/join-edugram').then((mod) => ({
    default: mod.JoinEdugram1,
  }))
)

const JoinEdugram2 = dynamic(() =>
  import('@public/static/icons/join-edugram').then((mod) => ({
    default: mod.JoinEdugram2,
  }))
)

// import {
//   FacebookNewIcon,
//   GoogleNewIcon,
//   InstaeNewIcon,
//   TwitterNewIcon,
//   YoutubeNewIcon,
// } from '@public/static/icons/social-icons'
// import dynamic from 'next/dynamic'

const FacebookNewIcon = dynamic(() =>
  import('@public/static/icons/social-icons').then((mod) => ({
    default: mod.FacebookNewIcon,
  }))
)

const GoogleNewIcon = dynamic(() =>
  import('@public/static/icons/social-icons').then((mod) => ({
    default: mod.GoogleNewIcon,
  }))
)

const InstaeNewIcon = dynamic(() =>
  import('@public/static/icons/social-icons').then((mod) => ({
    default: mod.InstaeNewIcon,
  }))
)

const TwitterNewIcon = dynamic(() =>
  import('@public/static/icons/social-icons').then((mod) => ({
    default: mod.TwitterNewIcon,
  }))
)

const YoutubeNewIcon = dynamic(() =>
  import('@public/static/icons/social-icons').then((mod) => ({
    default: mod.YoutubeNewIcon,
  }))
)

import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { PercentIcon } from '@public/static/icons/landingPageIcons/percent-icon'
import { OnlineCourseIcon } from '@public/static/icons/landingPageIcons/online-course-icon'
import { SubscriptionsIcon } from '@public/static/icons/landingPageIcons/subscriptions-icon'
import { PodcastsIcon } from '@public/static/icons/landingPageIcons/podcasts-icon'
import { edugramGoals } from '@constants/authorBenefits'
import { getFragmentedText } from '@utils/getFragmentedText'
import { Image } from '@nextui-org/react-latest'
import Head from 'next/head'
// import AuthorBenefits from '@components/pages/benefits/AuthorBenefits'
// import GoalCardComponent from '@components/pages/benefits/GoalCard'
// import MainAuthorBenefits from '@components/pages/benefits/MainAuthorBenefits'
// import ConnectWithUs from '@components/pages/benefits/ConnectWIthUs'
// import HowItWorks from '@components/pages/become-author/KeyBenefits/HowItWorks'
import dynamic from 'next/dynamic'
import withLenis from '@components/HOCs/LenisWrapper'

const AuthorBenefits = dynamic(
  () => import('@components/pages/benefits/AuthorBenefits')
)
const GoalCardComponent = dynamic(
  () => import('@components/pages/benefits/GoalCard')
)
const MainAuthorBenefits = dynamic(
  () => import('@components/pages/benefits/MainAuthorBenefits')
)
const ConnectWithUs = dynamic(
  () => import('@components/pages/benefits/ConnectWIthUs')
)
const HowItWorks = dynamic(
  () => import('@components/pages/become-author/KeyBenefits/HowItWorks')
)
const FAQSection = dynamic(
  () => import('@components/pages/advantageous/FAQSection')
)

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'footer',
        'landingPage',
        'advantageous',
      ])),
    },
  }
}

const menuItems = [
  {
    id: 1,
    link: '#aboutedu',
    translationKey: 'whatIsEdugram',
  },
  {
    id: 2,
    link: '#edubenefits',
    translationKey: 'benefits',
  },
  {
    id: 3,
    link: '#edugoal',
    translationKey: 'ourGoal',
  },
  {
    id: 4,
    link: '#howitworks',
    translationKey: 'howItWorks',
  },
]

const Landing = () => {
  const { t, i18n } = useTranslation(['footer', 'landingPage'])
  const dimentions = useWindowDimensions()
  const [selectedGoal, setSelectedGoal] = useState(1)
  const [direction, setDirection] = useState<'forward' | 'backward'>('forward')
  const [selectedButton, setSelectedButton] = useState(0)
  const [goalMargin, setGoalMargin] = useState(0)
  const [isMouseDown, setIsMouseDown] = useState(false)
  const [checkMouseState, setCheckMouseState] = useState('')

  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const startTimeRef = useRef<number | null>(null)
  const remainingTimeRef = useRef<number>(3000)
  const pauseTimeRef = useRef<number | null>(null)
  const [previousTime, setPreviousTime] = useState<number>(0)
  const handleNextCard = () => {
    if (!isMouseDown) {
      setDirection('backward')
      setSelectedGoal((prevState) => (prevState === 1 ? 3 : prevState - 1))
    }
  }

  useEffect(() => {
    intervalRef.current = setInterval(handleNextCard, remainingTimeRef.current)

    if (!isMouseDown) {
      startTimeRef.current = Date.now()
    }

    if (checkMouseState === 'up') {
      remainingTimeRef.current = 3000
      setCheckMouseState('')
    }

    return () => {
      clearInterval(intervalRef.current as NodeJS.Timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGoal, isMouseDown])

  useEffect(() => {
    setPreviousTime(0)
    remainingTimeRef.current = 3000
  }, [selectedGoal])

  const handleMouseDown = () => {
    setIsMouseDown(true)
    clearInterval(intervalRef.current as NodeJS.Timeout)
    pauseTimeRef.current = Date.now()
  }

  const handleMouseUp = () => {
    setCheckMouseState('up')
    setIsMouseDown(false)
    const timeDifferenceInSeconds =
      startTimeRef.current && pauseTimeRef.current
        ? Math.abs(startTimeRef.current - pauseTimeRef.current)
        : 0
    remainingTimeRef.current = Math.max(
      0,
      3200 - timeDifferenceInSeconds - previousTime
    )
    setPreviousTime((pre) => {
      return pre + timeDifferenceInSeconds
    })
    clearInterval(intervalRef.current as NodeJS.Timeout)
    intervalRef.current = setInterval(handleNextCard, remainingTimeRef.current)
  }
  const handleGoadlCardClick = (clickedGoalNumber) => {
    if (clickedGoalNumber === selectedGoal) {
      return
    } else if (clickedGoalNumber === (selectedGoal % 3) + 1) {
      setDirection('forward')
      setSelectedGoal((prevState) => (prevState % 3) + 1)
    } else {
      setDirection('backward')
      setSelectedGoal((prevState) => (prevState === 1 ? 3 : prevState - 1))
    }
  }
  useEffect(() => {
    if ((dimentions.width || 0) > 900) setGoalMargin(400)
    else if ((dimentions.width || 0) > 400)
      setGoalMargin((dimentions.width || 0) / 3)
    else setGoalMargin((dimentions.width || 0) / 4)
  }, [dimentions])

  const [showMenu, setShowMenu] = useState(false)

  return (
    <>
      <Head>
        <title>{t('ourBenefits', { ns: 'landingPage' })}</title>
        <meta
          name="og:title"
          content={t('ourBenefits', { ns: 'landingPage' })}
        />
        <meta name="description" content={t('description')} />
        <meta
          name="og:description"
          content={t('description', { ns: 'landingPage' })}
        />
        <link rel="canonical" href={`https://www.edugram.io/benefits/`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={t('ourBenefits', { ns: 'landingPage' })}
        />
        <meta
          name="twitter:description"
          content={t('description', { ns: 'landingPage' })}
        />
        <meta property="og:type" content="video_lecture" />
        <meta property="og:site_name" content="Edugram.io" />
        <meta property="og:locale" content={i18n.language} />
        <meta name="twitter:domain" content="www.edugram.io" />
        <meta
          name="keywords"
          content={
            'Edugram Benefits, Edugram.io, education, courses, learning, resources, skills, online learning, personalized learning, career coaching, personal development, skill development, professional development, '
          }
        />
      </Head>
      <LandingWrapper>
        <UpperBlock>
          <UpperBlockWrapper>
            <HeaderWrapper>
              <LeftHeader>
                <Link href={'/'}>
                  <NewLogo
                    width={
                      (dimentions.width || 0) < 800
                        ? (dimentions.width || 0) < 500
                          ? '220'
                          : '45vw'
                        : '353'
                    }
                  ></NewLogo>
                </Link>
                {/* ANCHOR - MENU ITEMS DESKTOP */}
                <MenuButtonsWrapper>
                  {menuItems.map((item) => (
                    <div key={item.id}>
                      <Link href={item.link}>
                        <MenuButton
                          onMouseOver={() => setSelectedButton(item.id)}
                          onMouseLeave={() => setSelectedButton(0)}
                        >
                          {t(item.translationKey, { ns: 'landingPage' })}
                        </MenuButton>
                        <motion.div
                          style={{
                            background: '#7181FF',
                            height: 5,
                            width: 0,
                            margin: 'auto',
                            borderRadius: 5,
                          }}
                          initial={{ width: 0 }}
                          animate={{
                            width: selectedButton === item.id ? '40%' : 0,
                          }}
                          transition={{ ease: 'linear', duration: 0.12 }}
                        />
                      </Link>
                    </div>
                  ))}
                </MenuButtonsWrapper>
              </LeftHeader>

              <Link href="/author/become-author">
                <JoinUsButton>
                  {t('joinUs', { ns: 'landingPage' })}
                </JoinUsButton>
              </Link>
              <HamburgerWrapper
                onClick={() => {
                  setShowMenu(!showMenu)
                }}
              >
                <motion.div
                  style={{ height: '100%' }}
                  initial={{ transform: 'rotate(0deg)' }}
                  animate={{
                    transform: showMenu ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                  transition={{ duration: 0.42 }}
                >
                  <AnimatePresence initial={false}>
                    {showMenu ? (
                      <CrossMenu></CrossMenu>
                    ) : (
                      <HamburgerMenuIcon width="100%" />
                    )}
                  </AnimatePresence>
                </motion.div>
              </HamburgerWrapper>
              {/* ANCHOR - MENU ITEMS MOBILE */}
              <MenuWrapper style={{ height: showMenu ? 310 : 0 }}>
                {menuItems.map((item, index) => (
                  <div
                    key={item.id}
                    style={{ marginTop: index === 0 ? 30 : 0 }}
                  >
                    <Link href={item.link}>
                      <MenuButton
                        onMouseOver={() => setSelectedButton(item.id)}
                        onMouseLeave={() => setSelectedButton(0)}
                      >
                        {t(item.translationKey, { ns: 'landingPage' })}
                      </MenuButton>
                      <motion.div
                        style={{
                          background: '#7181FF',
                          height: 5,
                          width: 0,
                          margin: 'auto',
                          borderRadius: 5,
                        }}
                        initial={{ width: 0 }}
                        animate={{
                          width: selectedButton === item.id ? '40%' : 0,
                        }}
                        transition={{ ease: 'linear', duration: 0.12 }}
                      ></motion.div>
                    </Link>
                  </div>
                ))}
                <Link href="/author/become-author">
                  <JoinUsButtonBenefits style={{ marginTop: 10 }}>
                    {t('joinUs', { ns: 'landingPage' })}
                  </JoinUsButtonBenefits>
                </Link>
              </MenuWrapper>
            </HeaderWrapper>
            <SloganBlock>
              <UpperSlogan>
                <div
                  style={{ position: 'absolute', top: 0, left: 0, zIndex: -1 }}
                >
                  <Gradient1 />
                </div>
                {getFragmentedText(t('mainSlogan', { ns: 'landingPage' }))}
                <Link href="/author/become-author">
                  <GetStartedButton>
                    {' '}
                    {t('getStartedNow', { ns: 'landingPage' })}
                  </GetStartedButton>
                </Link>
              </UpperSlogan>
              <IconWrapper>
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: -1,
                  }}
                >
                  <Gradient2 />
                </div>
                <LandingHeaderIllustration width="100%"></LandingHeaderIllustration>
              </IconWrapper>
            </SloganBlock>
          </UpperBlockWrapper>
        </UpperBlock>
        <FeaturesButtons>
          <FeatureButton>
            <FeatureButtonInner>
              <PercentIcon
                width={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 700
                      ? '30px'
                      : '4vw'
                    : '57px'
                }
              />
              {t('shortBenefits.noCommission', { ns: 'landingPage' })}
            </FeatureButtonInner>
          </FeatureButton>
          <FeatureButton>
            <FeatureButtonInner>
              <OnlineCourseIcon
                width={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 700
                      ? '30px'
                      : '4vw'
                    : '57px'
                }
              />
              {t('shortBenefits.onlineCourses', { ns: 'landingPage' })}
            </FeatureButtonInner>
          </FeatureButton>
          <FeatureButton>
            <FeatureButtonInner>
              <LiveCourseIcon
                width={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 700
                      ? '30px'
                      : '4vw'
                    : '57px'
                }
              />
              {t('shortBenefits.liveCourses', { ns: 'landingPage' })}
            </FeatureButtonInner>
          </FeatureButton>
          <FeatureButton>
            <FeatureButtonInner>
              <SubscriptionsIcon
                width={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 700
                      ? '30px'
                      : '4vw'
                    : '57px'
                }
              />
              {t('shortBenefits.subscriptions', { ns: 'landingPage' })}
            </FeatureButtonInner>
          </FeatureButton>
          <FeatureButton>
            <FeatureButtonInner>
              <PodcastsIcon
                width={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 700
                      ? '30px'
                      : '4vw'
                    : '57px'
                }
              />
              {t('shortBenefits.podcasts', { ns: 'landingPage' })}
            </FeatureButtonInner>
          </FeatureButton>
        </FeaturesButtons>
        <OurPartnersWrapper>
          <OurPartnersHeader id="aboutedu">
            {t('ourPartners', { ns: 'landingPage' })}
          </OurPartnersHeader>
          <PartnersList>
            <PartnerImageWrapper>
              <Image
                alt={'Oracle logo'}
                src={'/static/images/Oracle_logo.svg.png'}
                height={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 850
                      ? 14
                      : (dimentions.width || 0) * 0.0167
                    : 26
                }
              />
            </PartnerImageWrapper>
            <PartnerImageWrapper>
              <Image
                alt={'AWS logo'}
                src={'/static/images/512px-Amazon_Web_Services_Logo.svg.png'}
                height={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 850
                      ? 29
                      : (dimentions.width || 0) * 0.034
                    : 53
                }
              />
            </PartnerImageWrapper>
            <PartnerImageWrapper>
              <Image
                alt={'Oracle logo'}
                src={'/static/images/498px-Slack_Technologies_Logo.svg.png'}
                height={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 850
                      ? 22
                      : (dimentions.width || 0) * 0.0257
                    : 40
                }
              />
            </PartnerImageWrapper>
            <PartnerImageWrapper>
              <Image
                alt={'Oracle logo'}
                src={'/static/images/Android_logo_(2015-2019).svg.png'}
                height={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 850
                      ? 21
                      : (dimentions.width || 0) * 0.0237
                    : 37
                }
              />
            </PartnerImageWrapper>
            <PartnerImageWrapper>
              <Image
                alt={'Oracle logo'}
                src={'/static/images/Adobe_Corporate_logo.svg.png'}
                height={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 850
                      ? 23
                      : (dimentions.width || 0) * 0.0289
                    : 45
                }
              />
            </PartnerImageWrapper>
            <PartnerImageWrapper>
              <Image
                alt={'Oracle logo'}
                src={'/static/images/zoover.svg'}
                height={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 850
                      ? 20
                      : (dimentions.width || 0) * 0.0224
                    : 35
                }
              />
            </PartnerImageWrapper>
          </PartnersList>
        </OurPartnersWrapper>
        <EdugramForWrapper>
          <EdugramForHeader>
            {t('edugramFor', { ns: 'landingPage' })}
          </EdugramForHeader>
          <EdugramForText>
            {getFragmentedText(t('edugramForCreators', { ns: 'landingPage' }))}
          </EdugramForText>
          <EdugramForButtonsWrapper>
            <EdugramForButtonCreator>
              {t('creators', { ns: 'landingPage' })}
            </EdugramForButtonCreator>
            <EdugramForButton>
              {t('parents', { ns: 'landingPage' })}
            </EdugramForButton>
            <EdugramForButton>
              {t('students', { ns: 'landingPage' })}
            </EdugramForButton>
          </EdugramForButtonsWrapper>
        </EdugramForWrapper>
        <UpperBlock>
          {/* ANCHOR - BENEFITS FOR CREATORS */}
          <BenefitsForCreatorsWrapper id="edubenefits">
            {(dimentions.width || 0) < 1100 || (
              <>
                <BenefitsForCreatorsHeader>
                  {t('benefitsForCreators', { ns: 'landingPage' })}
                </BenefitsForCreatorsHeader>
                <BenefitsForCreatorsSubHeader>
                  {t('benefitsForCreatorsSubtitle', { ns: 'landingPage' })}
                </BenefitsForCreatorsSubHeader>
              </>
            )}
            <MainAuthorBenefits />
          </BenefitsForCreatorsWrapper>
        </UpperBlock>
        {/* ANCHOR - TRULY ALL IN ONE PLATFORM */}
        <BenefitsBlocks>
          <BenefitsForCreatorsHeader
            style={{ textAlign: 'center', padding: '0 15px' }}
          >
            {t('trulyAllInOnePlarform', { ns: 'landingPage' })}
          </BenefitsForCreatorsHeader>
          <BenefitsForCreatorsSubHeader
            style={{ textAlign: 'center', padding: '0 15px' }}
          >
            {t('trulyAllInOnePlarformSubtitle', { ns: 'landingPage' })}
          </BenefitsForCreatorsSubHeader>
          <BenefitBlocksWrapper>
            <AuthorBenefits />
          </BenefitBlocksWrapper>
        </BenefitsBlocks>
        {/* ANCHOR - OUR GOALS */}
        <OurGoalGlobalWrapper id="edugoal">
          <OurGoalWrapper>
            <OurGoal>{t('ourGoal', { ns: 'landingPage' })}</OurGoal>
            <GoalCardsWrapper>
              {edugramGoals.map((goal, index) => (
                <GoalCardComponent
                  key={index}
                  goalNumber={index + 1}
                  selectedGoal={selectedGoal}
                  direction={direction}
                  goalMargin={goalMargin}
                  title={goal.titleKey}
                  description={goal.descriptionKey}
                  icon={goal.icon}
                  onClick={() => handleGoadlCardClick(index + 1)}
                  onMouseDown={handleMouseDown}
                  onMouseUp={handleMouseUp}
                  isMouseDown={isMouseDown}
                />
              ))}
            </GoalCardsWrapper>
          </OurGoalWrapper>
        </OurGoalGlobalWrapper>
        {/* ANCHOR - HOW IT WORKS */}
        {/* <HowItWorksWrapper id="howitworks">
          <BenefitsForCreatorsHeader
            style={{
              margin: 'auto',
              width: 'max-content',
              marginBottom: (dimentions.width || 0) < 731 ? -20 : 60,
              marginTop: -10,
            }}
          >
            {t('howItWorks', { ns: 'landingPage' })}
          </BenefitsForCreatorsHeader>
          <HowItWorksLineOne
            style={{
              flexDirection:
                (dimentions.width || 0) < 731 ? 'column-reverse' : 'row',
            }}
          >
            <CurveOne>
              <StepNumber>#1</StepNumber>
            </CurveOne>
            <HowItWorksTextWrapper>
              {(dimentions.width || 0) < 731 && (
                <StepNumber
                  style={{
                    marginLeft: -35,
                    fontSize: 20,
                    position: 'absolute',
                    width: 'max-content',
                    height: 35,
                  }}
                >
                  #1
                </StepNumber>
              )}
              <HowItWorksHeader>
                {t('createYourCourse', { ns: 'landingPage' })}
              </HowItWorksHeader>
              <HowItWorksText>
                {t('createYourCourseDetail', { ns: 'landingPage' })}
              </HowItWorksText>
            </HowItWorksTextWrapper>
            <RightImageWrapper style={{ borderLeft: 0 }}>
              <Gradient2
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: 'auto',
                }}
              ></Gradient2>
              <HowItWorksOne
                width={(dimentions.width || 0) < 1561 ? '23vw' : '359'}
                right={(dimentions.width || 0) < 1561 ? '10vw' : '100'}
                position={(dimentions.width || 0) < 731 ? 'static' : 'absolute'}
              ></HowItWorksOne>
            </RightImageWrapper>
          </HowItWorksLineOne>
          <HowItWorksLineOne>
            <LeftImageWrapper>
              <Gradient2
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: 'auto',
                  opacity: 0.19,
                }}
              ></Gradient2>
              <HowItWorksTwo
                width={(dimentions.width || 0) < 1561 ? '23vw' : '359'}
              ></HowItWorksTwo>
            </LeftImageWrapper>
            <CurveTwo>
              <StepNumber
                style={{
                  margin: 0,
                  marginLeft: (dimentions.width || 0) < 1561 ? '1.5vw' : 25,
                }}
              >
                #2
              </StepNumber>
            </CurveTwo>
            <TextTwoWrapper>
              {(dimentions.width || 0) < 731 && (
                <StepNumber
                  style={{
                    marginLeft: -35,
                    fontSize: 20,
                    position: 'absolute',
                    width: 'max-content',
                    height: 35,
                  }}
                >
                  #2
                </StepNumber>
              )}
              <HowItWorksHeader>
                {t('addDetailsWithEase', { ns: 'landingPage' })}
              </HowItWorksHeader>
              <HowItWorksText>
                {t('addDetailsWithEaseDetail', { ns: 'landingPage' })}
              </HowItWorksText>
            </TextTwoWrapper>
          </HowItWorksLineOne>
          <HowItWorksLineOne
            style={{
              flexDirection:
                (dimentions.width || 0) < 731 ? 'column-reverse' : 'row',
            }}
          >
            <CurveThree>
              <StepNumber
                style={{
                  margin: 0,
                  marginLeft: (dimentions.width || 0) < 1561 ? '-2vw' : -30,
                }}
              >
                #3
              </StepNumber>
            </CurveThree>
            <TextTwoWrapper
              style={{
                paddingBottom: (dimentions.width || 0) < 1561 ? '6.5vw' : 100,
                paddingLeft: 40,
                borderBottom:
                  (dimentions.width || 0) > 730 ? '2px dashed #7282FD' : 0,
              }}
            >
              {(dimentions.width || 0) < 731 && (
                <StepNumber
                  style={{
                    marginLeft: -35,
                    fontSize: 20,
                    position: 'absolute',
                    width: 'max-content',
                    height: 35,
                  }}
                >
                  #3
                </StepNumber>
              )}
              <HowItWorksHeader>
                {t('publishwithConfidence', { ns: 'landingPage' })}
              </HowItWorksHeader>
              <HowItWorksText>
                {t('publishwithConfidenceDetail', { ns: 'landingPage' })}
              </HowItWorksText>
            </TextTwoWrapper>
            <RightImageWrapper style={{ paddingTop: 40 }}>
              <Gradient2
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: 'auto',
                  opacity: 0.2,
                }}
              ></Gradient2>
              <HowItWorksThree
                width={(dimentions.width || 0) < 1561 ? '21vw' : '339'}
                position={(dimentions.width || 0) < 731 ? 'static' : 'absolute'}
              ></HowItWorksThree>
            </RightImageWrapper>
          </HowItWorksLineOne>
          <HowItWorksLineOne>
            <LeftImageWrapper style={{ borderBottom: 0 }}>
              <Gradient2
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: 'auto',
                  opacity: 0.23,
                }}
              ></Gradient2>
              <HowItWorksFour
                width={(dimentions.width || 0) < 1561 ? '23vw' : '355'}
              ></HowItWorksFour>
            </LeftImageWrapper>
            <CurveTwo
              style={{
                maxHeight: 50,
                borderBottomRightRadius: 0,
                borderBottom: 0,
                marginLeft: 20,
              }}
            >
              <StepNumber
                style={{
                  margin: 0,
                  marginLeft: (dimentions.width || 0) < 1561 ? '1.5vw' : 25,
                }}
              >
                #4
              </StepNumber>
            </CurveTwo>
            <TextTwoWrapper style={{ borderLeft: 0 }}>
              {(dimentions.width || 0) < 731 && (
                <StepNumber
                  style={{
                    marginLeft: -35,
                    fontSize: 20,
                    position: 'absolute',
                    width: 'max-content',
                    height: 35,
                  }}
                >
                  #4
                </StepNumber>
              )}
              <HowItWorksHeader>
                {t('startSellingandInspire', { ns: 'landingPage' })}
              </HowItWorksHeader>
              <HowItWorksText>
                {t('startSellingandInspireDetail', { ns: 'landingPage' })}
              </HowItWorksText>
            </TextTwoWrapper>
          </HowItWorksLineOne>
        </HowItWorksWrapper> */}
        <HowItWorks isForBenefitsPage={true} />
        <JoinEdugramWrapper>
          <JoinEdugramInnerWrappery>
            {(dimentions.width || 0) < 800 || (
              <div
                style={{
                  flex: 1,
                  paddingLeft: 15,
                  alignSelf: 'flex-end',
                  marginBottom: -10,
                }}
              >
                <JoinEdugram1></JoinEdugram1>
              </div>
            )}

            <BenefitsForCreatorsWrapper
              style={{
                background: 0,
                padding: '30px 10px',
                textAlign: 'center',
                flex: 2,
                margin: 0,
              }}
            >
              <BenefitsForCreatorsHeader>
                {t('joinEdugram', { ns: 'landingPage' })}
              </BenefitsForCreatorsHeader>
              <BenefitsForCreatorsSubHeader>
                {t('joinEdugramSlogan', { ns: 'landingPage' })}
              </BenefitsForCreatorsSubHeader>

              <Link href="/author/become-author">
                <JoinUsButtonBenefits>
                  {t('joinNow', { ns: 'landingPage' })}
                </JoinUsButtonBenefits>
              </Link>
            </BenefitsForCreatorsWrapper>
            {(dimentions.width || 0) < 800 || (
              <div
                style={{
                  flex: 1,
                  paddingRight: 15,
                  marginBottom: -10,
                  textAlign: 'right',
                  alignSelf: 'center',
                }}
              >
                <JoinEdugram2></JoinEdugram2>
              </div>
            )}
          </JoinEdugramInnerWrappery>
        </JoinEdugramWrapper>
        {/* Connect with EDU modal start */}
        {/* <ConnectWithUsModal isOpen={isOpen} onOpenChange={onOpenChange} /> */}
        {/* Connect with EDU modal end  */}
        {/* Connect WIth US */}
        <ConnectWithUs />
        <FAQSection />
        <FooterWrapper>
          <div>
            <div style={{ marginLeft: 5 }}>
              <NewLogo
                width={
                  (dimentions.width || 0) < 1561
                    ? (dimentions.width || 0) < 1025
                      ? '290'
                      : '22vw'
                    : '353'
                }
              ></NewLogo>
            </div>
            <FooterHeading style={{ marginTop: 30 }}>
              {t('socialNetwork', {
                ns: 'landingPage',
              })}
            </FooterHeading>
            <div style={{ display: 'flex', marginTop: 10, gap: 12 }}>
              <GoogleNewIcon></GoogleNewIcon>
              <FacebookNewIcon></FacebookNewIcon>
              <InstaeNewIcon></InstaeNewIcon>
              <YoutubeNewIcon></YoutubeNewIcon>
              <TwitterNewIcon></TwitterNewIcon>
            </div>
          </div>
          <FooterInfoWrapper>
            <FooterInfoBlock>
              <FooterHeading>{t('homeFooterLinks.aboutUs')}</FooterHeading>
              <FooterText>{t('homeFooterLinks.becomeATeacher')}</FooterText>
              <FooterText>{t('homeFooterLinks.ourGoal')}</FooterText>
              <FooterText>{t('homeFooterLinks.support')}</FooterText>
            </FooterInfoBlock>
            <FooterInfoBlock>
              <FooterHeading>
                {t('homeFooterLinks.possibilities')}
              </FooterHeading>
              <FooterText>{t('homeFooterLinks.premium')}</FooterText>
              <FooterText>{t('homeFooterLinks.jobs')}</FooterText>
              <FooterText>{t('homeFooterLinks.parents')}</FooterText>
              <FooterText>{t('homeFooterLinks.business')}</FooterText>
            </FooterInfoBlock>
            <FooterInfoBlock>
              <FooterHeading>{t('homeFooterLinks.cooperation')}</FooterHeading>
              <FooterText>{t('homeFooterLinks.becomeATeacher')}</FooterText>
              <FooterText>{t('homeFooterLinks.parents')}</FooterText>
              <FooterText>{t('homeFooterLinks.certificates')}</FooterText>
              <FooterText>{t('homeFooterLinks.awards')}</FooterText>
            </FooterInfoBlock>
            <FooterInfoBlock>
              <FooterHeading>{t('homeFooterLinks.fAQ')}</FooterHeading>
              <FooterText>{t('homeFooterLinks.howItWorks')}</FooterText>
              <FooterText>{t('homeFooterLinks.business')}</FooterText>
              <FooterText>{t('homeFooterLinks.awards')}</FooterText>
            </FooterInfoBlock>
          </FooterInfoWrapper>
        </FooterWrapper>
        <FooterWrapper style={{ padding: 0, margin: 'auto', border: 0 }}>
          <FooterText style={{ marginLeft: 30, paddingBottom: 10 }}>
            {t('homeFooterLinks.copyRight')}
          </FooterText>
        </FooterWrapper>
      </LandingWrapper>
    </>
  )
}

export default withLenis(Landing)
